import { jsx as _jsx } from "react/jsx-runtime";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Root } from '../styles';
const TextInput = (props) => {
    const { id, caption, tooltip, value, contentType = 'text', size = 'small', big = false, suffix = '', inside = false, disabled = false, button = false, onChange, } = props;
    const onValueChange = (e) => {
        if (onChange) {
            const val = e?.target?.value;
            if (contentType === 'number') {
                if (!Number.isNaN(Number(val))) {
                    onChange(Number(val));
                }
            }
            else {
                onChange(val);
            }
        }
    };
    const inputProps = {
        ...(suffix
            ? {
                endAdornment: _jsx(InputAdornment, { position: "end", children: suffix }),
            }
            : {}),
    };
    return (_jsx(Root, { size: size, inside: inside, button: button, children: _jsx(TextField, { id: id, label: caption, helperText: tooltip, value: value, variant: "outlined", disabled: disabled, InputProps: inputProps, size: big ? 'medium' : 'small', fullWidth: inside, onChange: onValueChange }) }));
};
export default TextInput;
//# sourceMappingURL=TextInput.js.map